import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "209.001",
  height: "208",
  viewBox: "0 0 209.001 208"
}
const _hoisted_2 = {
  id: "survey-svg-2-1-linear-gradient",
  x1: "0.5",
  x2: "0.5",
  y2: "1",
  gradientUnits: "objectBoundingBox"
}
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_5 = {
  id: "survey-svg-2-1-linear-gradient-2",
  x1: "0.5",
  x2: "0.5",
  y2: "1",
  gradientUnits: "objectBoundingBox"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "0",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_7 = ["stop-color"]
const _hoisted_8 = {
  id: "ti_1",
  transform: "translate(-58 -117)"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  id: "减去_44",
  "data-name": "减去 44",
  d: "M-872.5-1061a105.769,105.769,0,0,1-21.061-2.113,104.348,104.348,0,0,1-19.616-6.06,104.688,104.688,0,0,1-17.751-9.589,105.158,105.158,0,0,1-15.466-12.7,104.858,104.858,0,0,1-12.76-15.392,103.849,103.849,0,0,1-9.635-17.666,103.114,103.114,0,0,1-6.089-19.522A104.284,104.284,0,0,1-977-1165a104.291,104.291,0,0,1,2.123-20.96,103.118,103.118,0,0,1,6.089-19.522,103.856,103.856,0,0,1,9.635-17.666,104.854,104.854,0,0,1,12.76-15.392,105.14,105.14,0,0,1,15.466-12.7,104.686,104.686,0,0,1,17.751-9.589,104.341,104.341,0,0,1,19.616-6.06A105.762,105.762,0,0,1-872.5-1269a105.759,105.759,0,0,1,21.06,2.113,104.347,104.347,0,0,1,19.616,6.06,104.678,104.678,0,0,1,17.751,9.589,105.142,105.142,0,0,1,15.466,12.7,104.86,104.86,0,0,1,12.76,15.392,103.851,103.851,0,0,1,9.635,17.666,103.115,103.115,0,0,1,6.089,19.522A104.289,104.289,0,0,1-768-1165a104.284,104.284,0,0,1-2.123,20.959,103.111,103.111,0,0,1-6.089,19.522,103.843,103.843,0,0,1-9.635,17.666,104.862,104.862,0,0,1-12.76,15.392,105.154,105.154,0,0,1-15.466,12.7,104.688,104.688,0,0,1-17.751,9.589,104.35,104.35,0,0,1-19.616,6.06A105.767,105.767,0,0,1-872.5-1061Zm0-205a102.741,102.741,0,0,0-20.456,2.052,101.354,101.354,0,0,0-19.053,5.885,101.668,101.668,0,0,0-17.241,9.312,102.121,102.121,0,0,0-15.022,12.333,101.846,101.846,0,0,0-12.394,14.948,100.862,100.862,0,0,0-9.358,17.156,100.133,100.133,0,0,0-5.914,18.959A101.263,101.263,0,0,0-974-1165a101.263,101.263,0,0,0,2.062,20.355,100.129,100.129,0,0,0,5.914,18.959,100.866,100.866,0,0,0,9.358,17.156,101.857,101.857,0,0,0,12.394,14.948,102.122,102.122,0,0,0,15.022,12.333,101.675,101.675,0,0,0,17.241,9.312,101.356,101.356,0,0,0,19.053,5.885A102.733,102.733,0,0,0-872.5-1064a102.732,102.732,0,0,0,20.456-2.052,101.356,101.356,0,0,0,19.052-5.885,101.67,101.67,0,0,0,17.241-9.312,102.12,102.12,0,0,0,15.022-12.333,101.839,101.839,0,0,0,12.394-14.948,100.856,100.856,0,0,0,9.358-17.156,100.125,100.125,0,0,0,5.914-18.959A101.263,101.263,0,0,0-771-1165a101.263,101.263,0,0,0-2.062-20.355,100.133,100.133,0,0,0-5.914-18.959,100.86,100.86,0,0,0-9.358-17.156,101.828,101.828,0,0,0-12.394-14.948,102.12,102.12,0,0,0-15.022-12.333,101.66,101.66,0,0,0-17.241-9.312,101.351,101.351,0,0,0-19.052-5.885A102.739,102.739,0,0,0-872.5-1266Z",
  transform: "translate(1035 1386)",
  fill: "url(#survey-svg-2-1-linear-gradient)"
}, null, -1)
const _hoisted_10 = ["fill"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  id: "baogaotixing",
  d: "M158.178,114.626H185.9a6.952,6.952,0,0,0,6.947-6.947v-.033A6.952,6.952,0,0,0,185.9,100.7H158.178a6.952,6.952,0,0,0-6.947,6.947v.033A6.952,6.952,0,0,0,158.178,114.626Zm44.251-7.056h-4.965v.087a11.587,11.587,0,0,1-11.585,11.585H158.2a11.587,11.587,0,0,1-11.585-11.585v-.087H141.65a11.15,11.15,0,0,0-11.15,11.15v60.954a11.15,11.15,0,0,0,11.15,11.15h60.779a11.15,11.15,0,0,0,11.15-11.15V118.72A11.157,11.157,0,0,0,202.429,107.571Zm-10.888,56.772h-39a2.787,2.787,0,0,1,0-5.575h39a2.787,2.787,0,1,1,0,5.575Zm.163-22.289H152.375a2.793,2.793,0,0,1,0-5.575h39.34a2.792,2.792,0,0,1-.011,5.575Z",
  transform: "translate(-9.5 63.195)",
  fill: "url(#survey-svg-2-1-linear-gradient-2)"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'survey-svg-2-1',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", _hoisted_2, [
        _createElementVNode("stop", {
          offset: "0",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("linearGradient", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("g", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("ellipse", {
        id: "椭圆_397",
        "data-name": "椭圆 397",
        cx: "88.5",
        cy: "88",
        rx: "88.5",
        ry: "88",
        transform: "translate(74 133)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_10),
      _hoisted_11
    ])
  ]))
}
}

})